import { withFields } from 'app-webtech-core/beacon/withFields';
import { SHOW_ITEM_DETAIL, VOD_EPISODE_WATCH } from '../actions/types';
import { vodEpisodePreviewBeacon } from './vodEpisodePreview';
import { vodEpisodeWatchBeacon } from './vodEpisodeWatch';

export const vodGuideEventDefinitionsMap = {
  [SHOW_ITEM_DETAIL]: withFields(vodEpisodePreviewBeacon),
  [VOD_EPISODE_WATCH]: withFields(vodEpisodeWatchBeacon),
};
